export default {
    compensoryPicks: {
        2022: {
            3: ['Steve']
        },
        2023: {},
        2024: {},
        2025: {},
        2026: {},
    },
    2022: {
        order: ['Taylor', 'Mike', 'Steve', 'Zane', 'Tench', 'Dan', 'Tommy', 'Kieffer', 'Aidan', 'Conor', 'Scott', 'Davis'],
        faab: {
            Tommy: 100, 
            Zane: 0, 
            Steve: 100, 
            Tench: 150, 
            Davis: 100, 
            Taylor: 100, 
            Mike: 100, 
            Aidan: 125, 
            Scott: 100, 
            Dan: 100, 
            Kieffer: 100, 
            Conor: 125
        }
    },
    2023: {
        order: ['Steve', 'Tench', 'Mike', 'Dan', 'Aidan', 'Davis', 'Zane', 'Tommy', 'Kieffer', 'Taylor', 'Scott', 'Conor'],
        faab: {
            Tommy: 53, 
            Zane: 0, 
            Steve: 100, 
            Tench: 125, 
            Davis: 147, 
            Taylor: 100, 
            Mike: 100, 
            Aidan: 175, 
            Scott: 100, 
            Dan: 100, 
            Kieffer: 100, 
            Conor: 100
        }
    },
    2024: {
        // TODO stop using this, 
        order: ['Conor', 'Mike', 'Dan', 'Kieffer', 'Davis', 'Scott', 'Steve', 'Aidan', 'Zane', 'Tench', 'Taylor', 'Tommy'],
        faab: {
            Tommy: 100, 
            Zane: 100, 
            Steve: 100, 
            Tench: 100, 
            Davis: 70, 
            Taylor: 100, 
            Mike: 115, 
            Aidan: 100, 
            Scott: 100, 
            Dan: 100, 
            Kieffer: 100, 
            Conor: 115
        }
    },
    2025: {
        order: ['Zane', 'Scott', 'Steve', 'Dan', 'Kieffer', 'Tommy', 'Aidan', 'Conor', 'Mike', 'Taylor', 'Tench', 'Davis'],
        faab: {
            Tommy: 100, 
            Zane: 100, 
            Steve: 100, 
            Tench: 100, 
            Davis: 100, 
            Taylor: 100, 
            Mike: 100, 
            Aidan: 100, 
            Scott: 100, 
            Dan: 100, 
            Kieffer: 100, 
            Conor: 100
        }
    },
    2026: {
        projectedOrder: true,
        order: ['Conor', 'Mike', 'Dan', 'Kieffer', 'Davis', 'Scott', 'Steve', 'Aidan', 'Zane', 'Tench', 'Taylor', 'Tommy'],
        faab: {
            Tommy: 100, 
            Zane: 100, 
            Steve: 100, 
            Tench: 100, 
            Davis: 100, 
            Taylor: 100, 
            Mike: 100, 
            Aidan: 100, 
            Scott: 100, 
            Dan: 100, 
            Kieffer: 100, 
            Conor: 100
        }
    },
    2027: {
        projectedOrder: true,
        order: ['Conor', 'Mike', 'Dan', 'Kieffer', 'Davis', 'Scott', 'Steve', 'Aidan', 'Zane', 'Tench', 'Taylor', 'Tommy'],
        faab: {
            Tommy: 100, 
            Zane: 100, 
            Steve: 100, 
            Tench: 100, 
            Davis: 100, 
            Taylor: 100, 
            Mike: 100, 
            Aidan: 100, 
            Scott: 100, 
            Dan: 100, 
            Kieffer: 100, 
            Conor: 100
        }
    }
}